
import { Component, Injector, Input, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { MAXIMUN_NUMBER_OF_ITEMS_RETURNED, NUMBER_OF_ITEM_DISPLAYED, PLEASE_USE_PAGINATION_BUTTON } from '../../../ui/Constants';
import { TreeNodeMeddraLevel } from '../../../ui/Node/MeddraNode/ListEntity/TreeNodeMeddraLevel';
import { QueryResultNode } from '../../../ui/Node/QueryResultNode';
import { QueryNodeMessageBox } from '../../../ui/Node/WebTraderNode/QueryNodeMessageBox';
import { SimpleSearchListNode } from '../../../ui/Node/SimpleSearchListNode';
import { MeddraNode } from '../../../ui/Node/MeddraNode/MeddraNode';
import { FormlyView } from '../../../ui/Data/FormlyView';
import { Art57Section } from '../../../ui/Art57Section/Art57Section';
import { testingEnum } from '../../../common/enum/testingEnum';
import { WebtraderService } from '../../../service/webtrader-service/webtrader.service';
@Component({
  selector: 'app-disclaimer-item-finder',
  templateUrl: './disclaimer-item-finder.component.html',
  styleUrls: ['./disclaimer-item-finder.component.scss']
})
export class DisclaimerItemFinderComponent implements OnInit {
  @Input() selectedNode: any;
  startText: string = "";
  endText: string = "";
  displayNumber: number = 0;
  content: string | undefined;
  loadMessage: boolean = false;

  constructor(private injector: Injector) { }

  ngOnInit(): void {
    this.loadMessage = true;
  }

  getMaxNumberRowsReturned(): number {
    return environment.maxNumberRowsReturned
  }

  showDisclaimerForDataResult(): boolean {
    console.log('Selected node:', this.selectedNode.data.model);
    return ((!(this.selectedNode instanceof TreeNodeMeddraLevel)) &&
      (!(this.selectedNode instanceof SimpleSearchListNode)) &&
      (this.selectedNode.data.model)) ||
      this.isArrayModel(true) ||
      this.isTreeModel();
  }

  isTreeNodeMeddraLevel(): boolean {
    return this.isTreeModel();
  }

  isResultNode(node: any) {
    return node instanceof QueryResultNode;
  }

  isInboxOutbox(): boolean {
    return this.selectedNode instanceof QueryNodeMessageBox;
  }

  isArrayModel(showresultsValueToCheck: boolean) {
    let showresults = false;
    if (this.selectedNode.hasOwnProperty('showResults')) {
      showresults = this.selectedNode.showResults;
    }

    return (this.selectedNode instanceof TreeNodeMeddraLevel || this.selectedNode instanceof SimpleSearchListNode) &&
      this.selectedNode.data.model &&
      this.selectedNode.data.model.length > 0 &&
      showresults === showresultsValueToCheck;
  }

  isTreeModel() {
    let showresults = false;
    if (this.selectedNode.hasOwnProperty('showResults')) {
      showresults = this.selectedNode.showResults;
    }

    return (this.selectedNode instanceof TreeNodeMeddraLevel ||
      (this.selectedNode instanceof MeddraNode && (!(this.selectedNode.data instanceof FormlyView))) ||
      this.selectedNode instanceof SimpleSearchListNode) &&
      this.selectedNode.children!.length > 0 && !showresults;
  }

  loadDisclaimerForDataResult(): string {

    if (this.isTreeNodeMeddraLevel()) {
      this.startText = NUMBER_OF_ITEM_DISPLAYED;
      this.endText = "";
      this.displayNumber = this.selectedNode.children ? this.selectedNode.children.length : 0;
    }

    if (this.isArrayModel(true) || this.isInboxOutbox() || this.isResultNode(this.selectedNode)) {
      this.startText = NUMBER_OF_ITEM_DISPLAYED;
      this.endText = "";
      this.displayNumber = this.selectedNode.data.model ? this.selectedNode.data.model.length : 0;
    }

    if (this.loadMessage) {
      this.loadMaxNumberRowsMessage();
    }

    return `${this.startText} ${this.displayNumber} ${this.endText}`;
  }

  loadMaxNumberRowsMessage() {
    this.loadMessage = false;
    if (this.isEqualToMaxNumberRows() && this.isInitialPage()) {
      if (this.isResultNode(this.selectedNode)
          && !this.selectedNode.data.disclaimerDisplayed) {
        this.injector!.get(Art57Section).showTooltipMessage({
          severity: 'warn',
          detail: `${MAXIMUN_NUMBER_OF_ITEMS_RETURNED} ${environment.maxNumberRowsReturned}; ${PLEASE_USE_PAGINATION_BUTTON}`,
          life: environment.warningElapsedTime
        });
        this.selectedNode.data.disclaimerDisplayed=true;
      } else if (this.isArrayModel(true)) {
        this.injector!.get(Art57Section).showTooltipMessage({
          severity: 'warn',
          id: testingEnum.maxResultsRetrievedToastMsg,
          detail: `Only ${environment.maxNumberRowsReturned} results were retrieved.  Please refine your search criteria.`,
          life: environment.warningElapsedTime
        });
      }
    }
  }

  private isEqualToMaxNumberRows() { 
    const numberofEntityChildrenOrElements = this.isTreeModel()? this.selectedNode.children.length: this.selectedNode.data.model?this.selectedNode.data.model.length:0;
    return numberofEntityChildrenOrElements === this.getMaxNumberRowsReturned();
  }

  private isInitialPage() {
    if (this.selectedNode.paginationControl) {
      return this.selectedNode.paginationControl.currentPage === 0;
    } else {
      return true;
    }
  }

}